import { toast as sonnerToast } from 'svelte-sonner';

export type ToastType = 'info' | 'success' | 'warning' | 'error';

/**
 * Re-export showToast with the same signature as the previous hand-built store.
 * Maps info/success/warning/error to Sonner's toast methods.
 * Callers across the app use showToast(message, type?, duration?) unchanged.
 */
export function showToast(message: string, type: ToastType = 'info', duration?: number): void {
  // Default 3500ms matches the previous hand-built toast lifetime (Sonner's own default is 4000ms).
  const opts = { duration: duration ?? 3500 };
  switch (type) {
    case 'success':
      sonnerToast.success(message, opts);
      break;
    case 'warning':
      sonnerToast.warning(message, opts);
      break;
    case 'error':
      sonnerToast.error(message, opts);
      break;
    default:
      // default Sonner toast is info-style (neutral icon)
      sonnerToast.info(message, opts);
      break;
  }
}
